// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../variables.css\"","mobile-threshold-width":"610px","card":"ListItemMobile_card__1iTEm","bin":"ListItemMobile_bin__i8wWM"};